import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["name", "required", "pattern", "placeholder"];
const _hoisted_2 = ["name"];
import FormInput from "./FormInput.vue";
import AirDatepicker from "air-datepicker";
import 'air-datepicker/air-datepicker.css';
import { computed, onMounted, ref, useTemplateRef, watch } from "vue";
import { emulateReadonly, isMobile } from "../../utils";
import { formatISO9075 } from "date-fns";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Datepicker',
    props: /*@__PURE__*/ _mergeModels({
        label: String,
        name: { type: String, default: 'delivery_date' },
        required: Boolean,
        error: String,
        // datepicker config:
        minDate: Date,
        maxDate: Date,
        timepicker: Boolean,
        holidays: { type: Array, default: [] },
        disabledDays: { type: Array, default: [] },
        config: { type: Object, default: {} },
    }, {
        "modelValue": {},
        "modelModifiers": {},
        "date": {},
        "dateModifiers": {},
        "dateFormatted": {},
        "dateFormattedModifiers": {},
    }),
    emits: ["update:modelValue", "update:date", "update:dateFormatted"],
    setup(__props) {
        const props = __props;
        const input = useTemplateRef('input');
        const value = _useModel(__props, "modelValue");
        const dateModel = _useModel(__props, 'date');
        const dateFormatted = _useModel(__props, 'dateFormatted');
        const datepickerInstance = ref();
        const pattern = computed(() => `\\d\\d?\\.\\d\\d?\\.\\d{4}${props.timepicker ? ' ([01]?\\d|2[0-3]):([0-5]?\\d)' : ''}`);
        const placeholder = computed(() => `дд.мм.гггг${props.timepicker ? ' чч:мм' : ''}`);
        watch(() => [props.minDate, props.maxDate, props.disabledDays, props.holidays], () => {
            if (datepickerInstance.value) {
                datepickerInstance.value.destroy();
            }
            initDatepicker(props.minDate, props.maxDate, props.disabledDays, props.holidays, props.config);
        });
        onMounted(() => {
            const startDate = new Date();
            startDate.setHours(startDate.getHours() + (startDate.getHours() >= 22 ? 10 : 1), 0, 0);
            initDatepicker(props.minDate, props.maxDate, props.disabledDays, props.holidays, props.config);
        });
        function initDatepicker(minDate, maxDate, disabledDays, _holidays, config) {
            if (datepickerInstance.value) {
                datepickerInstance.value.destroy();
            }
            datepickerInstance.value = new AirDatepicker(input.value, Object.assign({ minDate,
                maxDate, autoClose: true, dateFormat: 'dd.MM.yyyy', position: 'top left', toggleSelected: false, isMobile, timepicker: props.timepicker, onRenderCell: ({ date, cellType }) => {
                    if (cellType === 'day') {
                        const dateFormatted = dateOnly(date);
                        return {
                            disabled: disabledDays.includes(dateFormatted),
                        };
                    }
                }, onSelect: ({ date, formattedDate }) => {
                    if (Array.isArray(date) || Array.isArray(formattedDate)) {
                        return;
                    }
                    value.value = formattedDate;
                    dateModel.value = date;
                    dateFormatted.value = formatDate(date);
                } }, config));
            validateDate(minDate, maxDate, disabledDays);
            emulateReadonly(input.value);
        }
        function validateDate(minDate, maxDate, disabledDays) {
            if (value.value !== '' && value.value !== undefined) {
                try {
                    const date = makeDate(value.value);
                    const dateFormatted = formatDate(date);
                    const minDateFormatted = formatDate(minDate);
                    const maxDateFormatted = formatDate(maxDate);
                    if (dateFormatted >= minDateFormatted && dateFormatted <= maxDateFormatted && !disabledDays.includes(dateOnly(date))) {
                        datepickerInstance.value.selectDate(date);
                    }
                    else {
                        datepickerInstance.value.unselectDate(date);
                        value.value = '';
                    }
                }
                catch (e) {
                    value.value = '';
                }
            }
        }
        function dateOnly(date) {
            return formatISO9075(date, { representation: "date" });
        }
        function formatDate(date) {
            if (props.timepicker) {
                return date.toISOString();
            }
            return dateOnly(date);
        }
        function makeDate(dateString) {
            dateString = dateString.replace(/^(\d{1,2})\.(\d{1,2})\.(\d{4})/, '$3-$2-$1');
            return new Date(dateString);
        }
        watch(value, () => validateDate(props.minDate, props.maxDate, props.disabledDays));
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(FormInput, {
                name: "delivery_date",
                label: __props.label,
                error: __props.error,
                required: __props.required,
                modelValue: value.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((value).value = $event))
            }, {
                default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: __props.name,
                        class: "form-control",
                        autocomplete: "off",
                        required: __props.required,
                        pattern: pattern.value,
                        placeholder: placeholder.value,
                        id: "card_delivery_date",
                        ref_key: "input",
                        ref: input,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((value).value = $event))
                    }, null, 8 /* PROPS */, _hoisted_1), [
                        [_vModelText, value.value]
                    ]),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    _withDirectives(_createElementVNode("input", {
                        type: "hidden",
                        name: `${__props.name}_formatted`,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((dateFormatted).value = $event))
                    }, null, 8 /* PROPS */, _hoisted_2), [
                        [_vModelText, dateFormatted.value]
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label", "error", "required", "modelValue"]));
        };
    }
});
